"use client";

import { ArrowDownWideNarrow } from "@/components/icons";
import { useHeroMapContext } from "@/components/home/context/hero-map-context";
import { useListingBrowseContext } from "./context/listing-browse-context";

// WHY: a label, not a control. Each seam behind these results answers exactly one order — the geospatial query ranks by distance, the search index by relevance, the nationwide index by the merchandising order — so offering a choice meant reordering whichever prefix had been fetched, which put one listing on two pages and another on none.
export function ResultsOrderLabel() {
  const { searchQuery, viewMode, sorting } = useListingBrowseContext();
  const { location } = useHeroMapContext();

  if (viewMode === "table" && sorting.length > 0) return null;

  const order = searchQuery.trim()
    ? "Best match"
    : location
      ? "Closest to you"
      : "Recommended";

  return (
    <span className="inline-flex items-center gap-1.5 text-sm text-muted-foreground max-md:text-xs">
      <ArrowDownWideNarrow className="h-4 w-4" aria-hidden />
      Sorted by
      <span className="font-medium text-foreground">{order}</span>
    </span>
  );
}
